(function($) {

  // Format les milliers des input
  $("input[name$='-capital'], input[name$='-mensualite']").keyup(function() {
    capital = $(this).val().replace(/\s/g,"");
    $(this).val(capital.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
  });


  // Format un nombre en monetaire
  function toMoney(num) {
    return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',');
  }

  /*
  ##     ##  ########   ##    ##    ######    ##     ##     ###     ##         ####  ########   ########    ######    
  ###   ###  ##         ###   ##   ##    ##   ##     ##    ## ##    ##          ##      ##      ##         ##    ##   
  #### ####  ##         ####  ##   ##         ##     ##   ##   ##   ##          ##      ##      ##         ##         
  ## ### ##  ######     ## ## ##    ######    ##     ##  ##     ##  ##          ##      ##      ######      ######    
  ##     ##  ##         ##  ####         ##   ##     ##  #########  ##          ##      ##      ##               ##   
  ##     ##  ##         ##   ###   ##    ##   ##     ##  ##     ##  ##          ##      ##      ##         ##    ##   
  ##     ##  ########   ##    ##    ######     #######   ##     ##  ########   ####     ##      ########    ######    
  */
  $("form[name='calc1']").submit(function() {

    $capital   = $("input[name='calc1-capital']");
    $duree     = $("input[name='calc1-duree']");
    $taux      = $("input[name='calc1-taux']");
    $assurance = $("input[name='calc1-assurance']");

    capital   = $capital.val().replace(/\s/g,"");
    mois      = $duree.val().replace(",", ".") * 12. ; // durée en mois
    taux      = $taux.val().replace(",", ".") / 1200. ; // taux pret mensuel
    assurance = $assurance.val().replace(",", ".") / 1200. ; // taux assurance mensuel

    taux_annuel = Math.pow(1.+taux, 12) - 1. ;
    // document.formulaire.taux_annuel.value = tannuel * 100. ;
    
    // taux_annuel( t ) ;

    // assurance = capital * taux_assurance /1200

    
    // cr = controle( "mensualite" ) ;
    // if ( cr != 0 ) return ;

    coef = Math.pow(1.+taux, mois) ;
    // si t -> 0 alors, coef -> 1+n*t
    if ( taux > 1.e-7 ) mensualite_pret = capital * taux * coef / (coef-1.) ;
    else                mensualite_pret = capital / mois ;

    // Résultats
    mensualite_assurance = capital * assurance;
    mensualite           = mensualite_pret + mensualite_assurance;
    cout                 = (mois * mensualite) - capital;

    $(this).find(".result").show();
    $("#calc1-mensualite").html(toMoney(mensualite) + " €");
    $("#calc1-cout").html(toMoney(cout) + " €");
    
    return false;

  });


  /*
   ######       ###     ########   ####  ########      ###     ##         
  ##    ##     ## ##    ##     ##   ##      ##        ## ##    ##         
  ##          ##   ##   ##     ##   ##      ##       ##   ##   ##         
  ##         ##     ##  ########    ##      ##      ##     ##  ##         
  ##         #########  ##          ##      ##      #########  ##         
  ##    ##   ##     ##  ##          ##      ##      ##     ##  ##         
   ######    ##     ##  ##         ####     ##      ##     ##  ########   
  */
  $("form[name='calc2']").submit(function() {

    $mensualite = $("input[name='calc2-mensualite']");
    $duree      = $("input[name='calc2-duree']");
    $taux       = $("input[name='calc2-taux']");
    $assurance  = $("input[name='calc2-assurance']");

    mensualite = $mensualite.val().replace(",", ".").replace(/\s/g,"");
    mois       = $duree.val().replace(",", ".") * 12. ; // durée en mois
    taux       = $taux.val().replace(",", ".") / 1200. ; // taux mensuel
    assurance  = $assurance.val().replace(",", ".") / 1200. ; // durée en mois

    taux_annuel = Math.pow(1.+taux, 12) - 1. ;   
    coef        = Math.pow(1.+taux, mois) ;
    c           = (coef-1.) / (taux * coef);

    /*** BASE ***/
    // mensualite_assurance = capital * assurance
    // capital              = mensualite_pret * (coef-1.) / (taux * coef) ;
    // mensualite           = mensualite_assurance + mensualite_pret;

    // capital                          = mensualite_assurance / assurance;
    // mensualite_pret                  = mensualite - mensualite_assurance;
    // mensualite_assurance / assurance = mensualite_pret * (coef-1.) / (taux * coef) ;
    // mensualite_pret                  = capital * taux * coef / (coef-1.);
    // capital                          = mensualite_pret * (coef-1.) / (taux * coef) ;

    // mensualite_assurance / assurance                        = mensualite_pret * c ;
    // mensualite_assurance                                    = (mensualite - mensualite_assurance) * c * assurance;
    // mensualite_assurance                                    = c*assurance*mensualite - c*assurance*mensualite_assurance;
    // mensualite_assurance + c*assurance*mensualite_assurance = c*assurance*mensualite;
    // mensualite_assurance * (1 + (c*assurance))              = c*assurance*mensualite;

    mensualite_assurance = (c * assurance * mensualite) / (1 + (c*assurance));
    mensualite_pret      = mensualite - mensualite_assurance;
    capital              = mensualite_pret * c ;
    cout                 = (mois * mensualite) - capital;

    // si t -> 0 alors, coef -> 1+n*t
    // if ( taux > 1.e-7 ) capital = mensualite_pret * (coef-1.) / (taux * coef) ;
    // else                capital = mensualite_pret * mois ;


    $(this).find(".result").show();
    $("#calc2-capital").html(toMoney(capital) + " €");
    $("#calc2-cout").html(toMoney(cout) + " €");

    return false;

  });


  // Durée
  $("form[name='calc3']").submit(function() {

    $mensualite = $("input[name='calc3-mensualite']");
    $capital    = $("input[name='calc3-capital']");
    $taux       = $("input[name='calc3-taux']");
    $assurance  = $("input[name='calc3-assurance']");

    mensualite = $mensualite.val().replace(",", ".").replace(/\s/g,"");
    capital    = $capital.val().replace(/\s/g,"");
    taux       = $taux.val().replace(",", ".") / 1200. ; // taux pret mensuel
    assurance  = $assurance.val().replace(",", ".") / 1200. ; // taux assurance mensuel

    taux_annuel = Math.pow(1.+taux, 12) - 1. ;


    mensualite_assurance = capital * assurance;
    mensualite_pret      = mensualite - mensualite_assurance;
 
    if ( taux > 1.e-7 ) mois = (Math.log(mensualite_pret) - Math.log(mensualite_pret-capital*taux)) / Math.log(1.+taux) ;
    else                mois = capital / mensualite_pret ;

    cout                 = (mois * mensualite) - capital;
 
    $(this).find(".result").show();
    $("#calc3-duree").html(Math.ceil(mois) + " mois");
    $("#calc3-cout").html(toMoney(cout) + " €");

    return false;

  });


})(jQuery);
